import domReady from '@wordpress/dom-ready';
import manifest from '../manifest.json';

domReady(async () => {
	const { blockJsClass } = manifest;

	const blockContainerElements = document.querySelectorAll('.js-panel-container');

	if (!blockContainerElements.length) {
		return;
	}

	const { Panel } = await import('./panel');

	[...blockContainerElements].forEach((containerElement) => {
		const panel = new Panel({
			panelElementSelector: `.${blockJsClass}`,
			mustIntersect: '.js-expandable-pricing-table-panel-target',
			upperBoundary: '.js-price-card',
			lowerBoundary: '.js-panel-force-stop',
			containerElement,
			intersectionContainerMinimum: 160,
			intersectionUpperBoundaryMinimum: 20,
		});

		panel.init();
	});
});
